import gql from 'graphql-tag';

export default gql`
  mutation finishEvent($message: String!, $untreatedEventOptionId: Int) {
    finish(message: $message, untreatedEventOptionId: $untreatedEventOptionId)
  }
`;
